import { useRouter } from '@tanstack/react-router';
import { ArrowRight, Filter, SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface NoResultsProps {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

export function NoResults({ hasActiveFilters, onClearFilters }: NoResultsProps) {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center px-4 py-20">
      <div className="w-full max-w-sm space-y-6 text-center">
        <div className="relative mx-auto w-fit">
          <SearchX className="h-16 w-16 animate-pulse text-slate-300 dark:text-slate-600" />
          <div className="absolute -end-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/50">
            <span className="text-xs font-bold text-red-500 dark:text-red-400">0</span>
          </div>
        </div>

        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-foreground">לא נמצאו תוצאות</h2>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {hasActiveFilters
              ? 'לא נמצאו פריטים המתאימים. נסה להרחיב את החיפוש או לנקות חלק מהמסננים.'
              : 'לא נמצאו פריטים כרגע. נסה שוב מאוחר יותר.'}
          </p>
        </div>

        <div className="flex flex-col gap-2">
          {hasActiveFilters && (
            <Button
              onClick={onClearFilters}
              className="w-full gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 border-0 text-white font-medium hover:from-blue-700 hover:to-indigo-700"
            >
              <Filter className="h-4 w-4" />
              נקה את כל המסננים
            </Button>
          )}
          <Button variant="outline" onClick={() => router.history.back()} className="w-full gap-2">
            <ArrowRight className="h-4 w-4" />
            חזור אחורה
          </Button>
        </div>
      </div>
    </div>
  );
}
